import { metricConfig } from './metricConfigBuilder';

export const getXDEFlavouredMetrics = (
	selectedMetrics,
	serviceID = 'PhoenixTimePeriod',
) => {
	const xdeFormattedTPMetrics = [];
	const xdeFormattedTSMetrics = [];
	const groupedMap = new Map();
	if (metricConfig) {
		Object.keys(metricConfig).forEach(key => {
			const metric = metricConfig[key];
			const exists = selectedMetrics.some(
				({ metric: m }) => m === metric.code,
			);

			if (!groupedMap.has(metric.code)) {
				const metricObj = {
					colHelp: metric.displayName,
					colId: metric.code,
					colText: metric.displayName,
					dropDowns: serviceID !== 'PhoenixTimeSeries' &&
						metric.isTimePeriodMetric
						? getXDEFlavouredTimeperiods(
							metric,
							selectedMetrics,
						) : [],
					expand: false,
					fieldType: null,
					groupId: 'Optional',
					mandatoryYN: null,
					selected: exists,
				};
				if (
					serviceID === 'PhoenixTimeSeries' &&
					metric.isTimeSeriesMetric
				) {
					xdeFormattedTSMetrics.push(metricObj);
				} else {
					xdeFormattedTPMetrics.push(metricObj);
				}
				groupedMap.set(metric.code);
			}
		});
	} else {
		console.log('Metrics config is not ready');
	}

	const getTimePeriods = tp => {
		return tp != null ? tp : '';
	};

	const xdeMetricsOrder = selectedMetrics.map(metric => {
		// Might need to loop thru applicableTps and get the displayname for Tps, possibly a map is good.TODO
		const tp =
			serviceID === 'PhoenixTimePeriod'
				? getTimePeriods(metric.timeperiod)
				: '';
		return {
			colHelp: metric.metric,
			colId: metric.metric + (tp ? `|${tp}` : ''),
			colText: `${metricConfig[metric.metric]?.displayName} ${tp}`,
			mandatoryYN: 'N',
			fieldType: null,
			groupId: 'Optional',
			selected: true,
			expand: false,
			dropDowns: [],
		};
	});

	return {
		xdeFormattedMetrics:
			serviceID === 'PhoenixTimeSeries'
				? xdeFormattedTSMetrics
				: xdeFormattedTPMetrics,
		xdeMetricsOrder,
	};
};

const getXDEFlavouredTimeperiods = (metricObj, selectedMetrics) => {
	const xdeFormattedTimeperiods = [];
	if (!metricObj.isTimePeriodMetric) {
		return [];
	}
	const timeperiods = metricObj?.applicableTimeperiods;
	const metricCode = metricObj?.code;
	timeperiods.map(tp => {
		const exists = selectedMetrics.some(
			({ metric, timeperiod }) =>
				`${metric}|${timeperiod}` === `${metricCode}|${tp.name}`,
		);
		xdeFormattedTimeperiods.push({
			colText: tp.displayName,
			colId: `${metricCode}|${tp.name}`,
			dropDowns: [],
			expand: false,
			selected: exists,
		});
	});

	return xdeFormattedTimeperiods;
};

export const getPhxServiceSpecificMetrics = (serviceId, defaultMetrics) => {};
